<div
  *ngIf="showSection$ | async"
  class="dashboard-groups"
  data-cy="dashboard-custom-groups">

  <coa-dashboard-groups-header
    class="dashboard-groups-header">
  </coa-dashboard-groups-header>

  <coa-dashboard-groups-body
    [categoryId]="categoryId"
    [clientId]="clientId"
    [dateRange]="dateRange"
    class="dashboard-groups-body">
  </coa-dashboard-groups-body>
</div>


